/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PersonAvatar_person$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PeopleSelector_people$ref: FragmentReference;
declare export opaque type PeopleSelector_people$fragmentType: PeopleSelector_people$ref;
export type PeopleSelector_people = $ReadOnlyArray<{|
  +id: string,
  +databaseId: string,
  +name: string,
  +isAgent: boolean,
  +avatarUrl: string,
  +agentOperatorName: ?string,
  +$fragmentRefs: PersonAvatar_person$ref,
  +$refType: PeopleSelector_people$ref,
|}>;
export type PeopleSelector_people$data = PeopleSelector_people;
export type PeopleSelector_people$key = $ReadOnlyArray<{
  +$data?: PeopleSelector_people$data,
  +$fragmentRefs: PeopleSelector_people$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PeopleSelector_people",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAgent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agentOperatorName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonAvatar_person"
    }
  ],
  "type": "Person",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '3377cb4e366c10b8aa19da6e14124212';

module.exports = node;
